import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Languages } from "lucide-react";
import { toast } from "sonner";

const OPTIONS = [
  { key: "simple", label: "Simple", desc: "Sans jargon (ex: « 30 min en endurance facile »)" },
  { key: "standard", label: "Standard", desc: "Abréviations expliquées (ex: « endurance fondamentale (EF) »)" },
  { key: "expert", label: "Expert", desc: "Affichage technique et condensé (ex: « EF Z2 »)" },
];

export function DisplayLevelCard() {
  const [level, setLevel] = useState("standard");
  useEffect(() => { api.get("/profile/display-level").then((r) => setLevel(r.data.display_level)).catch(() => {}); }, []);
  const pick = async (k) => {
    setLevel(k);
    try { await api.post("/profile/display-level", { display_level: k }); toast.success("Préférence enregistrée"); }
    catch { toast.error("Erreur"); }
  };
  return (
    <div data-testid="display-level-card" className="rounded-xl border border-border bg-white p-6">
      <div className="text-xs tracking-[0.16em] uppercase font-semibold text-obsidian/50 flex items-center gap-2"><Languages size={15} /> Affichage du vocabulaire</div>
      <p className="mt-1 text-sm text-obsidian/50">Choisis à quel point le vocabulaire running est technique. La séance reste identique, seule la formulation change.</p>
      <div className="mt-4 grid sm:grid-cols-3 gap-2">
        {OPTIONS.map((o) => (
          <button key={o.key} data-testid={`display-level-${o.key}`} onClick={() => pick(o.key)}
            className={`text-left rounded-lg border px-3 py-3 transition-colors ${level === o.key ? "border-obsidian bg-obsidian text-white" : "border-border hover:border-obsidian/40"}`}>
            <div className="text-sm font-medium">{o.label}</div>
            <div className={`text-[11px] mt-0.5 ${level === o.key ? "text-white/70" : "text-obsidian/50"}`}>{o.desc}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
